import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppProvider } from '@context/AppContext';
import { AuthProvider } from '@context/AuthContext';
import { store } from '@store/index';
import { initSentry } from './lib/sentry';
import SentryErrorBoundary from '@components/common/ErrorBoundary';
import App from './App';
import './index.css';
import './i18n';

// Initialise Sentry before anything else renders.
// Safe no-op if VITE_SENTRY_DSN is not set.
initSentry();

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryErrorBoundary>
      <ReduxProvider store={store}>
        <QueryClientProvider client={queryClient}>
          <AppProvider>
            <AuthProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </AuthProvider>
          </AppProvider>
        </QueryClientProvider>
      </ReduxProvider>
    </SentryErrorBoundary>
  </StrictMode>,
);
